import * as Icons from 'lucide-react';
import { LucideIcon, BadgeIcon } from 'lucide-react';

interface DynamicIconProps {
    name: keyof typeof Icons;
    color?: string;
    size?: number;
    className?: string;
}

export const DynamicIcon: React.FC<DynamicIconProps> = ({ name, color, size, className }) => {
    const Icon = Icons[name] as LucideIcon;

    if (!Icon) {
        return <BadgeIcon size={size} className={className} color={color} />;
    }

    return <Icon color={color} size={size} className={className} />;
};